import moment from 'moment'

const validator = {
  message(field, { _max_, max }) {
    const value = _max_ || max
    const formatted = moment(value).format('DD.MM.YYYY')
    return field + ' muss am oder vor dem ' + formatted + ' liegen.'
  },
  params: ['max'],
  validate(value, { max }) {
    return max ? moment(value).isSameOrBefore(max) : true
  }
}
export default validator
